import './chatBotDataPagination.css';

const ChatBotDataPagination = ({ page, total, limit, onPageChange }) => {
    const totalPages = Math.ceil(total / limit);
    const start = total === 0 ? 0 : (page - 1) * limit + 1;
    const end = Math.min(page * limit, total);
    if (totalPages <= 1) return null;

    return (
        <div className='cbd-pagination'>
            <div className='cbd-page-info'>
                Showing {start}–{end} of {total} records
            </div>
            <button className='cbd-page-btn' disabled={page === 1} onClick={() => onPageChange(page - 1)}>
                Previous
            </button>

            <div className='cbd-page-numbers'>
                {Array.from({ length: totalPages }, (_, i) => (
                    <button
                        key={i}
                        className={`cbd-page-number ${page === i + 1 ? 'active' : ''}`}
                        onClick={() => onPageChange(i + 1)}
                    >
                        {i + 1}
                    </button>
                ))}
            </div>

            <button className='cbd-page-btn' disabled={page === totalPages} onClick={() => onPageChange(page + 1)}>
                Next
            </button>
        </div>
    );
};

export default ChatBotDataPagination;
